module.exports = __webpack_public_path__ + "static/img/warning.6bfc3127.svg";